export default "//0f174046-a3c4-46d7-88af-9cfef9e6bcb2.selcdn.net/webpack/production/80d6e5d73b2980581d94adb9e754b707.jpg";